<template>
  <card titulo="Firma">
    <template #acoes>
      <v-button v-if="exibirGerarFirma" :run="gerarFirma" :button="false" class="icon ml-2" position="dropleft" style="float: right;">
        GERAR FIRMA
      </v-button>
    </template>

    <card-table v-if="firma">
      <thead>
        <tr>
          <th width="48%">Firma</th>
          <th width="48%">Geração</th>
          <th width="4%" class="text-right"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{firma.firma}}</td>
          <td>{{firma.dataGeracaoFirma | datahora}}</td>
          <td>
            <FirmaBotoes v-if="exibirGerarFirma" :versao-id="pessoa.id"/>
          </td>
        </tr>
      </tbody>
    </card-table>
  </card>
</template>

<script>
import Card from "@/components/Layout/components/Card.vue";
import IndicadorPessoalBusiness from "@/business/indicadores/IndicadorPessoalBusiness";
import FrontBusiness from "@/business/FrontBusiness";
import CardTable from "@/components/Layout/components/CardTable.vue";

import FirmaBotoes from "@/components/IndicadorPessoal/Detalhes/Tabelionato/FirmaBotoes.vue";
import FirmaPendenciasHelper from "@/business/indicadores/FirmaPendenciasHelper";
import FormIndicadorPessoal from "@/components/IndicadorPessoal/Form/FormIndicadorPessoal";

export default {

  name: "Firma",
  components: {FirmaBotoes, CardTable, Card},
  props: {
    pessoa: Object
  },

  data() {
    return {
      firma: null,
      loading: false,
      processando: false
    }
  },

  computed: {
    exibirGerarFirma() {
      return this.$root.getPermission({id: 'PERMITIR_GERAR_CODIGO_FIRMA'});
    }
  },

  mounted() {
    if(this.pessoa.indicadorPessoal?.firma) {
      this.firma = {
        firma: this.pessoa.indicadorPessoal?.firma,
        dataGeracaoFirma: this.pessoa.indicadorPessoal?.dataGeracaoFirma
      }
    }
  },

  methods: {
    async gerarFirma() {
      if (this.processando) return;
      this.processando = true;
      try {
        await this._processarFirma(this.pessoa.id);
      } catch (e) {
        FrontBusiness.showError('', e.message);
      } finally {
        this.processando = false;
      }
    },

    async _processarFirma(id) {
      let validacao = await IndicadorPessoalBusiness.validarFirma(id);
      let { editaveis, somenteNaoEditaveis } = FirmaPendenciasHelper.filtrarPendenciasEditaveis(validacao.bloqueios);

      if (somenteNaoEditaveis) {
        FrontBusiness.showError('', validacao.bloqueios.map(b => b.mensagem).join('\n'));
        return;
      }

      let mostrouAvisoPendencias = false;
      while (editaveis && editaveis.length > 0) {
        let codigosAnteriores = (editaveis || []).map(e => e.codigo).sort().join(',');
        let camposPendentes = FirmaPendenciasHelper.mapearCamposPendentes(editaveis);
        if (!mostrouAvisoPendencias) {
          FrontBusiness.showWarn('', 'Existem pendências para a geração da firma. Preencha os campos destacados.');
          mostrouAvisoPendencias = true;
        }
        let retorno = await FrontBusiness.openModal(FormIndicadorPessoal, {
          versaoId: id,
          camposPendentes
        });

        if (!retorno) return; // usuário cancelou o editor

        this.$emit('pessoaAlterada', retorno);
        id = retorno.id;

        validacao = await IndicadorPessoalBusiness.validarFirma(id);
        let resultado = FirmaPendenciasHelper.filtrarPendenciasEditaveis(validacao.bloqueios);

        let codigosAtuais = (resultado.editaveis || []).map(e => e.codigo).sort().join(',');
        if (codigosAnteriores === codigosAtuais) {
          FrontBusiness.showWarn('', 'Nenhuma pendência foi resolvida. Preencha os campos destacados e salve novamente.');
        }

        editaveis = resultado.editaveis;

        if (resultado.somenteNaoEditaveis) {
          FrontBusiness.showError('', validacao.bloqueios.map(b => b.mensagem).join('\n'));
          return;
        }
      }

      if (validacao.alertas && validacao.alertas.length > 0) {
        for (let alerta of validacao.alertas) {
          let confirmou = await FrontBusiness.openConfirmacao(alerta.mensagem, 'Deseja continuar a geração da firma?');
          if (confirmou !== 'confirm') return;
        }
      }

      this.firma = await IndicadorPessoalBusiness.gerarFirma(id);
      this.$emit('firmaGerada', this.firma);
    },
  }
}
</script>
